// extracted by mini-css-extract-plugin
export default {"noSubmissionMessage":"noSubmissionMessage__DL3b6"};